export const products = [
  {
    id: 722,
    slug: 'turron-de-jijona-300',
    name: 'Turrón de Jijona',
    format: '300 g',
    price: 10,
    family: 'Clásicos',
    badge: 'Esencial',
    image: '/products-compact/jijona-300.webp',
    short: '70% de almendra Marcona, miel de naranjo o azahar y hasta 4 horas de Boixet.',
    ingredients: 'Almendra Marcona (70%), miel de naranjo o azahar, azúcar y clara de huevo.',
    process: 'La almendra tostada se une a la miel cocida, se muele y se refina. El Boixet trabaja la mezcla a fuego lento entre 3 y 4 horas hasta lograr su textura inconfundible.',
    allergens: 'Sin gluten. Contiene almendra y huevo. Puede contener trazas de otros frutos secos.',
  },
  {
    id: 707,
    slug: 'turron-de-jijona-500',
    name: 'Turrón de Jijona',
    format: '500 g',
    price: 16,
    family: 'Clásicos',
    image: '/products-compact/jijona-500.webp',
    short: 'El clásico blando de Jijona en formato familiar, con 70% de almendra Marcona.',
    ingredients: 'Almendra Marcona (70%), miel de naranjo o azahar, azúcar y clara de huevo.',
    process: 'Tostado, cocción de la miel, molienda y refinado preceden a una cocción lenta de 3 a 4 horas en Boixet.',
    allergens: 'Sin gluten. Contiene almendra y huevo. Puede contener trazas de otros frutos secos.',
  },
  {
    id: 702,
    slug: 'coqueta-de-jijona-500',
    name: 'Coqueta de Turrón de Jijona',
    format: '500 g',
    price: 16,
    family: 'Clásicos',
    image: '/products-compact/coqueta-jijona-500.webp',
    short: 'La receta de Jijona presentada en su tradicional formato redondo.',
    ingredients: 'Almendra Marcona (70%), miel de naranjo o azahar, azúcar y clara de huevo.',
    process: 'La mezcla refinada se homogeneiza lentamente en el Boixet y se moldea en formato circular.',
    allergens: 'Sin gluten. Contiene almendra y huevo. Puede contener trazas de otros frutos secos.',
  },
  {
    id: 724,
    slug: 'turron-de-alicante-300',
    name: 'Turrón de Alicante',
    format: '300 g',
    price: 10,
    family: 'Clásicos',
    badge: 'Crujiente',
    image: '/products-compact/alicante-300.webp',
    short: '62% de almendra Marcona tostada, miel y una fina oblea de arroz.',
    ingredients: 'Almendra Marcona (62%), miel de naranjo o azahar, azúcar, clara de huevo y oblea de harina de arroz.',
    process: 'La almendra tostada se mezcla con la miel cocida y se envasa en caliente entre obleas antes de reposar y cortarse.',
    allergens: 'Sin gluten (<20 ppm). Contiene almendra. Puede contener trazas de otros frutos secos, cacahuete, huevo y sésamo.',
  },
  {
    id: 709,
    slug: 'turron-de-alicante-500',
    name: 'Turrón de Alicante Duro',
    format: '500 g',
    price: 16,
    family: 'Clásicos',
    image: '/products-compact/alicante-500.webp',
    short: 'La expresión más rotunda del turrón duro, con 70% de almendra Marcona.',
    ingredients: 'Almendra Marcona (70%), miel de naranjo o azahar, azúcar y clara de huevo.',
    process: 'La mezcla se trabaja en caliente, se prensa en cajones y reposa antes del corte.',
    allergens: 'Sin gluten (<20 ppm). Contiene almendra. Puede contener trazas de otros frutos secos, cacahuete, huevo y sésamo.',
  },
  {
    id: 705,
    slug: 'torta-imperial-200',
    name: 'Torta Imperial',
    format: '200 g',
    price: 7,
    family: 'Clásicos',
    image: '/products-compact/torta-imperial-200.webp',
    short: 'Almendra Marcona, miel de azahar y oblea fina en una torta ligera y crujiente.',
    ingredients: 'Almendra Marcona (62%), miel de naranjo o azahar, azúcar, clara de huevo y oblea de harina de arroz.',
    process: 'El turrón se envasa caliente entre obleas y toma su forma redonda durante el reposo.',
    allergens: 'Sin gluten (<20 ppm). Contiene almendra. Puede contener trazas de otros frutos secos, cacahuete, huevo y sésamo.',
  },
  {
    id: 716,
    slug: 'turron-a-la-piedra-300',
    name: 'Turrón a la Piedra',
    format: '300 g',
    price: 11,
    family: 'Clásicos',
    badge: 'Selección',
    image: '/products-compact/piedra-300.webp',
    short: 'Almendra Marcona, limón y canela refinados entre piedras.',
    ingredients: 'Almendra Marcona (60%), azúcar, ralladura natural de limón y canela.',
    process: 'La almendra tostada, el azúcar y el limón se refinan entre piedras hasta alcanzar un cuerpo sedoso. Se envasa en madera y se termina con canela.',
    allergens: 'Sin gluten. Contiene almendra. Puede contener trazas de otros frutos de cáscara, huevo y cacahuete.',
  },
  {
    id: 734,
    slug: 'turron-de-guirlache-300',
    name: 'Guirlache · Terronico',
    format: '300 g',
    price: 10,
    family: 'Clásicos',
    image: '/products-compact/guirlache-300.webp',
    short: '70% de almendra Marcona con piel, miel caramelizada y ajonjolí.',
    ingredients: 'Almendra Marcona con piel (70%), miel de naranjo o azahar, azúcar y sésamo.',
    process: 'La miel y el azúcar se caramelizan sin clara de huevo y se mezclan con almendra tostada y sésamo antes de envasarse en caliente.',
    allergens: 'Sin gluten. Contiene almendra y sésamo. Puede contener trazas de otros frutos de cáscara, cacahuete y huevo.',
  },
  {
    id: 738,
    slug: 'chocolate-con-almendras-300',
    name: 'Chocolate con Almendras',
    format: '300 g',
    price: 10.5,
    family: 'Chocolate',
    badge: 'Favorito',
    image: '/products-compact/chocolate-almendra-300.webp',
    short: 'Chocolate fundido y almendras tostadas. Nada más, nada menos.',
    ingredients: 'Chocolate y almendras tostadas.',
    process: 'El chocolate se funde, se mezcla con la almendra y se vierte en grandes moldes. Una vez frío, se corta cada tableta.',
    allergens: 'Sin gluten. Contiene almendra y soja. Puede contener trazas de leche y cacahuete.',
  },
  {
    id: 714,
    slug: 'chocolate-con-almendras-500',
    name: 'Chocolate con Almendras',
    format: '500 g',
    price: 18,
    family: 'Chocolate',
    image: '/products-compact/chocolate-almendra-500.webp',
    short: 'Chocolate y almendras tostadas en un formato generoso para compartir.',
    ingredients: 'Chocolate y almendras tostadas.',
    process: 'El chocolate fundido envuelve la almendra antes de reposar en molde y cortarse en tabletas.',
    allergens: 'Sin gluten. Contiene almendra y soja. Puede contener trazas de leche y cacahuete.',
  },
  {
    id: 703,
    slug: 'torta-de-chocolate-200',
    name: 'Torta de Chocolate con Almendras',
    format: '200 g',
    price: 8,
    family: 'Chocolate',
    image: '/products-compact/torta-chocolate-200.webp',
    short: 'Una torta fina de chocolate con almendras tostadas enteras.',
    ingredients: 'Chocolate y almendras tostadas.',
    process: 'Se funde el chocolate, se incorpora la almendra y la mezcla se moldea antes de enfriar.',
    allergens: 'Sin gluten. Contiene almendra y soja. Puede contener trazas de leche y cacahuete.',
  },
  {
    id: 746,
    slug: 'chocolate-crujiente-200',
    name: 'Chocolate Crujiente',
    format: '200 g',
    price: 5.3,
    family: 'Chocolate',
    image: '/products-compact/chocolate-crujiente-200.webp',
    short: 'Ganache de cacao y avellana con cereales crujientes y baño de chocolate.',
    ingredients: 'Azúcar, leche en polvo, avellana, manteca y pasta de cacao, cereales extrusionados (8%), soja y vainilla. Cacao mínimo 18%.',
    process: 'Se crea una ganache con avellanas y cereal, se moldea, se corta en frío y se termina con un baño de chocolate.',
    allergens: 'Contiene avellana, leche y soja. Puede contener trazas de cacahuete y almendra.',
  },
  {
    id: 736,
    slug: 'yema-tostada-300',
    name: 'Turrón de Yema Tostada',
    format: '300 g',
    price: 9.5,
    family: 'Obrador',
    badge: 'Flameado',
    image: '/products-compact/yema-tostada-300.webp',
    short: 'Almendra y yema terminadas al rojo vivo para crear una fina capa caramelizada.',
    ingredients: 'Almendra cruda molida, azúcar y yema de huevo.',
    process: 'Tras el amasado y reposo, cada pastilla se espolvorea con azúcar y se quema con una plancha al rojo vivo.',
    allergens: 'Sin gluten. Contiene almendra y huevo. Puede contener trazas de otros frutos secos.',
  },
  {
    id: 711,
    slug: 'yema-tostada-500',
    name: 'Turrón de Yema Tostada',
    format: '500 g',
    price: 15.5,
    family: 'Obrador',
    image: '/products-compact/yema-tostada-500.webp',
    short: 'La yema tostada artesanal en formato familiar.',
    ingredients: 'Almendra cruda molida, azúcar y yema de huevo.',
    process: 'Amasado, reposo y corte preceden al tostado final del azúcar con plancha al rojo vivo.',
    allergens: 'Sin gluten. Contiene almendra y huevo. Puede contener trazas de otros frutos secos.',
  },
  {
    id: 732,
    slug: 'yema-natural-300',
    name: 'Turrón de Yema Natural',
    format: '300 g',
    price: 9.5,
    family: 'Obrador',
    image: '/products-compact/yema-natural-300.webp',
    short: 'Almendra molida, azúcar y yema, con una textura tierna y limpia.',
    ingredients: 'Almendra cruda molida, azúcar y yema de huevo.',
    process: 'Los ingredientes se amasan al punto, se dejan enfriar en cajones y se cortan al peso.',
    allergens: 'Sin gluten. Contiene almendra y huevo. Puede contener trazas de otros frutos secos.',
  },
  {
    id: 744,
    slug: 'mazapan-o-nieve-300',
    name: 'Turrón de Mazapán o Nieve',
    format: '300 g',
    price: 9.5,
    family: 'Obrador',
    image: '/products-compact/mazapan-300.webp',
    short: 'Mazapán fino con limón natural y una delicada capa de canela.',
    ingredients: 'Almendra cruda molida, azúcar, ralladura natural de limón y canela.',
    process: 'La masa se trabaja al punto, reposa en cajones y se espolvorea con canela antes del corte.',
    allergens: 'Sin gluten. Contiene almendra y huevo. Puede contener trazas de otros frutos secos.',
  },
  {
    id: 728,
    slug: 'turron-de-coco-300',
    name: 'Turrón de Coco',
    format: '300 g',
    price: 9.5,
    family: 'Obrador',
    image: '/products-compact/coco-300.webp',
    short: 'Almendra molida y coco rallado en una receta suave y aromática.',
    ingredients: 'Almendra cruda molida, azúcares y coco rallado.',
    process: 'La almendra, el coco y el azúcar se amasan hasta su punto y reposan antes del corte.',
    allergens: 'Sin gluten. Puede contener trazas de otros frutos de cáscara, cacahuete, leche y huevo.',
  },
  {
    id: 730,
    slug: 'turron-de-fruta-300',
    name: 'Turrón de Fruta',
    format: '300 g',
    price: 9.5,
    family: 'Obrador',
    image: '/products-compact/fruta-300.webp',
    short: 'Mazapán de limón con capas de fruta confitada.',
    ingredients: 'Almendra cruda molida, azúcares, fruta confitada y ralladura natural de limón.',
    process: 'La masa de almendra y limón se alterna con fruta confitada en capas y reposa antes de cortarse.',
    allergens: 'Sin gluten. Contiene almendra. Puede contener trazas de otros frutos de cáscara, cacahuete, sulfitos, huevo y leche.',
  },
]

export const families = ['Todos', 'Clásicos', 'Chocolate', 'Obrador']

export const euro = (value) =>
  new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(value)
